// Google Analytics 4 (GA4) カスタムイベントトラッキング

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

// Google Analytics設定
const GA4_ID = 'G-HG39BT85LN';

// 画像生成イベント
export const trackImageGeneration = (menuName: string, category: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'generate_image', {
      'event_category': 'engagement',
      'event_label': menuName,
      'menu_name': menuName,
      'category_name': category,
      'custom_dimension_1': menuName, // カスタムディメンション用
      'custom_dimension_2': category
    });
    console.log('GA4: Image generation tracked', { menuName, category });
  }
};

// グッズ作成イベント
export const trackMerchandiseCreation = (itemType: string, itemName: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'create_merchandise', {
      'event_category': 'conversion',
      'event_label': itemType,
      'item_type': itemType,
      'item_name': itemName,
      'custom_dimension_3': itemType, // グッズ種類
      'custom_dimension_4': itemName
    });
    console.log('GA4: Merchandise creation tracked', { itemType, itemName });
  }
};

// クレジットチャージイベント
export const trackCreditPurchase = (amount: number, credits: number) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'purchase', {
      'event_category': 'ecommerce',
      'event_label': `${credits} credits`,
      'value': amount,
      'currency': 'JPY',
      'credits_purchased': credits,
      'custom_metric_1': credits // カスタムメトリクス用
    });
    console.log('GA4: Credit purchase tracked', { amount, credits });
  }
};

// クレジット消費イベント
export const trackCreditUsage = (credits: number, action: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'spend_virtual_currency', {
      'event_category': 'engagement',
      'event_label': action,
      'value': credits,
      'virtual_currency_name': 'credits',
      'item_name': action
    });
    console.log('GA4: Credit usage tracked', { credits, action });
  }
};

// ページビューのトラッキング（SPA用）
export const trackPageView = (pagePath: string, pageTitle?: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'page_view', {
      'page_path': pagePath,
      'page_title': pageTitle || document.title
    });
  }
};

// ユーザーログインイベント
export const trackUserLogin = (method: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'login', {
      'method': method
    });
    console.log('GA4: User login tracked', { method });
  }
};

// ユーザー登録イベント
export const trackUserSignUp = (method: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'sign_up', {
      'method': method
    });
    console.log('GA4: User sign up tracked', { method });
  }
};

// 画像保存イベント（ライブラリへの保存）
export const trackImageSave = (imageType: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'save_to_library', {
      'event_category': 'engagement',
      'event_label': imageType,
      'content_type': 'image'
    });
    console.log('GA4: Image saved to library', { imageType });
  }
};

// 画像共有イベント
export const trackImageShare = (method: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'share', {
      'method': method,
      'content_type': 'image'
    });
    console.log('GA4: Image shared', { method });
  }
};

// エラートラッキング
export const trackError = (error: string, fatal: boolean = false) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'exception', {
      'description': error,
      'fatal': fatal
    });
    console.error('GA4: Error tracked', { error, fatal });
  }
};